const MODULES = {
  PARTNER_REQUESTS: "Requests",
  PARTNER_LIST: "Partner List",
  PARTNER_CRM_PLANS: "CRM Plans",

  LEAD_DETAILS: "Lead Details",
  LEAD_CAPTURE: "Lead Capture",
  LEAD_QUALIFICATION: "Lead Qualification",
  LEAD_ASSIGNMENT: "Lead Assignment",
  LEAD_REPORTS: "Lead Reports",
  LEAD_LOGS: "Lead Logs",
  ASSIGNED_LEADS: "Assigned Leads",
  ASSIGN_LEAD_OWNER: "Assign Lead Owner",

  CUSTOMER_PROFILE: "Customer Profile",
  CUSTOMER_ENGAGEMENT: "Customer Engagement",
  CUSTOMER_SUPPORT: "Support",

  CREATE_CAMPAIGNS: "Create Campaigns",
  VIEW_CAMPAIGNS: "View Campaigns",
  CAMPAIGN_PERFORMANCE_METRICS: "Campaign Performance Metrics",
  LANDINGPAGE: "Landing Page",
  HUBSPOT: "HubSpot",

  CREATE_SURVEYS: "Create Surveys",
  VIEW_SURVEYS: "View Surveys",
  EMAIL_TEMPLATES: "Email Templates",
  LETTER_TEMPLATES: "Letter Templates",

  QR_CODE_LIST: "QR Codes List",
  // UNSUBSCRIBED_USERS: "Unsubscribed Users",
  GENERAL_NOTES: "General Notes",

  ORDER_MANAGEMENT: "Order Management",
  PAYMENTS: "Payments",
  SUBSCRIPTION_REPORT: "Subscription Report",

  USER_REQUESTS: "User Requests",
  USER_LISTS: "User List",
  USER_ROLES_AND_PERMISSIONS: "User Roles & Permissions",
  USER_REPORTS: "User Report",

  USAGE_METRICS: "Usage Metrics / Utilization",
  LANDING_PAGE: "Landing Page",

  TENANT_MANAGEMENT: "Partner Management",
  USER_MANAGEMENT: "User Management",
  LEAD_MANAGEMENT: "Lead Management",
  CAMPAIGNS: "Campaigns",
  CUSTOMER_MANAGEMENT: "Customer Management",
  DASHBOARDS: "Dashboards",
  CUSTOMER_PROFILE_DASHBOARDS: "Customer Profile Dashboards",
  TEMPLATES_AND_QRS: "Templates & QRs",
  LOGOUT: "Logout",
  SETTINGS: "Settings",
  TRACK_UPLOADS: "Track Uploads",
  IMPORT: "Import",
  EXPORT: "Export",

  SUPPORT_TICKETS: "Tickets",
  GUIDES: "Guides",
  AI_CALL_MONITORING: "AI Call Monitoring",
};

export default MODULES;
